<template>
  <el-popover :placement="placement" v-model="display">
    <p>确定删除？</p>
    <div>
      <el-button
        style="width: 100%"
        type="primary"
        size="mini"
        :loading="loading"
        @click="confirm"
        >确定</el-button
      >
    </div>
    <slot slot="reference"></slot>
  </el-popover>
</template>

<script>
export default {
  name: "DeletePopover",
  props: {
    placement: {
      type: String,
      default: () => "left"
    }
  },
  data() {
    return {
      display: false,
      loading: false
    };
  },
  beforeCreate() {
    this.$eventbus.$on("ResetDeleteIconButton", () => {
      this.display = false;
      this.loading = false;
    });
  },
  methods: {
    confirm() {
      this.loading = true;
      this.$emit("delete");
    }
  }
};
</script>

<style scoped></style>
